import React from "react";
import ReactDOM from "react-dom/client";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
// import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ChonkyIconFA } from "chonky-icon-fontawesome";
import { setChonkyDefaults } from "chonky";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "@fontsource/poppins/400.css";
import { AuthLanding, Home, Portal, Register } from "./features";
import PrivateRoutes from "./utils/privateRoutes";

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_DSN,
//   integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <Routes>
        <Route index element={<Home />} />
        <Route element={<PrivateRoutes />}>
          <Route path="/portal/*" element={<Portal />} />
        </Route>
        <Route path="login" element={<AuthLanding />} />
        <Route path="register" element={<Register />} />
      </Routes>
    </Router>
  </QueryClientProvider>
);

setChonkyDefaults({ iconComponent: ChonkyIconFA });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
